// Disclosure navigation with top-level links (WAI-ARIA APG pattern).
// The link navigates; the adjacent button opens the panel for keyboard and
// assistive-technology users. Mouse hover is handled in CSS and is unchanged.
(() => {
  const toggles = document.querySelectorAll('.mega-menu__toggle');
  if (!toggles.length) return;

  // Only one panel is open at a time; track it so clicks and focus changes elsewhere on the
  // page do no DOM writes (each attribute write also feeds every page MutationObserver).
  let openToggle = null;

  const setOpen = (toggle, open) => {
    if (open) {
      if (openToggle && openToggle !== toggle) openToggle.setAttribute('aria-expanded', 'false');
      openToggle = toggle;
    } else if (openToggle === toggle) {
      openToggle = null;
    }
    if (toggle.getAttribute('aria-expanded') !== String(open)) toggle.setAttribute('aria-expanded', String(open));
  };

  toggles.forEach((toggle) => {
    const item = toggle.closest('li');

    toggle.addEventListener('click', () => {
      setOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
    });

    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true') return;
      setOpen(toggle, false);
      toggle.focus();
      event.stopPropagation();
    });

    item.addEventListener('focusout', (event) => {
      if (openToggle === toggle && !item.contains(event.relatedTarget)) setOpen(toggle, false);
    });
  });

  document.addEventListener('click', (event) => {
    if (openToggle && !event.target.closest('.header__inline-menu li')) setOpen(openToggle, false);
  });
})();
